<script setup>

defineBuilderComponent({
    friendlyName: 'Hero',
    ignored: true
})
</script>

<template>
  <section class="relative block overflow-hidden">

    <video
        poster="/assets/images/page_cajamarca.jpg"
        autoplay="autoplay"
        loop
        class="absolute z-10 object-cover w-full h-full brightness-75"
        muted="muted"
        playsinline="playsinline"
    >
      <source
          type="video/mp4"
          src="/assets/videos/18585941-Hd.mp4"
      />
    </video>
    <div
        class="relative flex items-center justify-end px-5 py-2 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:items-center"
    >
      <div class="flex-grow block" style="width: 65px">
        <nuxt-img
            width="128"
            height="91"
            class="relative z-20 pt-4 pl-4 w-36"
            src="/assets/images/logo-white.svg"
            alt="Lifeboost Coffee Logo"
        />
      </div>
      <a
          href="tel:1-800-479-1596"
          class="z-20 flex px-4 py-3 text-white no-underline uppercase lg:px-6 whitespace-nowrap font-ww-medium justify-self-end phone hover:underline"
      >1-800-479-1596</a
      >
    </div>

    <div>
      <div
          class="relative z-20 grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12"
      >
        <div class="order-2 w-full mr-auto lg:order-1 place-self-center lg:col-span-12">
          <h1
              class="mb-4 font-extrabold text-center text-white drop-shadow-2xl h1"
          >
            "The Hidden Treasure of Cajamarca: Rony Lavan's Coffee Wonderland Unlocks the Secrets of Peru's Prized Microlots"
          </h1>
          <p
              class="max-w-3xl m-auto mb-6 font-normal text-center text-white lg:mb-8 h3"
          >
            Discover Sustainable Farming and Unrivaled Quality in Every Bean For a Sensational Coffee Experience

          </p>

          <button
              @click="scrollTo('the-products')"
              class="items-center block m-auto justify-center px-10 uppercase text-sm lg:text-lg hover:shadow-lg text-center font-ginger leading-4 bg-lifeboost-red text-white hover:opacity-80 rounded-full py-3.5 xl:py-4 px-7 xl:px-9 transition-all"> Buy Now </button>

        </div>
        <!--      <div class="order-1 w-1/2 mx-auto lg:col-span-5 lg:flex lg:mt-0 lg:order-2 lg:w-auto">-->
        <!--        <nuxt-img-->
        <!--            width="497"-->
        <!--            height="673"-->
        <!--            sizes="1360:497px 1040px:calc(32vw + 68px) calc(50vw - 16px)"-->
        <!--            src="/assets/images/assets_3e94875091f14b5fbf2446148f458738_6103f0463abc43ff8db895d2274147cf.png"-->
        <!--            alt="Rainbow Luxe"-->
        <!--            preload-->
        <!--            format="webp"-->
        <!--        />-->
        <!--      </div>-->
      </div>
    </div>
  </section>
</template>

<style scoped></style>
